import React from 'react';
import { Box, List, ListItem, Typography, IconButton, Collapse } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import * as COLOR from '../../../../../constants/colors';
import { QuestionListProps } from '../types';
import { REFERRER_BENEFITS_ANSWER_TEXT_ONLY } from '../constants';

export const QuestionList: React.FC<QuestionListProps> = ({
  questions,
  selectedIndex,
  onQuestionClick,
  isMobile,
  expandedItems,
  onMobileToggle,
  selectedTab,
}) => {
  if (questions.length === 0) {
    return (
      <List sx={{ flex: 1, p: 0 }}>
        <ListItem sx={{ px: 2, py: 1.5 }}>
          <Typography
            sx={{
              fontSize: 18,
              fontWeight: 400,
              color: COLOR.GREY1,
              textAlign: "left",
              width: "100%",
            }}
          >
            目前沒有相關常見問題
          </Typography>
        </ListItem>
      </List>
    );
  }

  return (
    <List sx={{ flex: 1, p: 0 }}>
      {questions.map((faq, index) => {
        const isSelected = selectedIndex === index;
        const itemKey = `${selectedTab}-${index}`;
        const isExpanded = expandedItems[itemKey] || false;

        return (
          <Box key={`${selectedTab}-${faq.question}`}>
            <ListItem
              onClick={() => {
                if (isMobile) {
                  onMobileToggle(itemKey);
                } else {
                  onQuestionClick(index);
                }
              }}
              sx={{
                px: 2,
                py: 1.5,
                mb: 1,
                borderRadius: 1,
                cursor: "pointer",
                backgroundColor: isMobile 
                  ? "transparent" 
                  : (isSelected ? COLOR.COLOR_SECONDARY : "transparent"),
                "&:hover .faq-question-text": {
                  color: isMobile 
                    ? COLOR.COLOR_SECONDARY
                    : (isSelected ? "white" : COLOR.COLOR_SECONDARY),
                },
              }}
              role="button"
              tabIndex={0}
              aria-expanded={isMobile ? isExpanded : undefined}
              aria-selected={!isMobile ? isSelected : undefined}
              onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                  e.preventDefault();
                  if (isMobile) {
                    onMobileToggle(itemKey);
                  } else {
                    onQuestionClick(index);
                  }
                }
              }}
            >
              <Typography
                className="faq-question-text"
                sx={{
                  fontSize: 18,
                  fontWeight: 400,
                  color: isMobile 
                    ? COLOR.GREY1 
                    : (isSelected ? "white" : COLOR.GREY1),
                  textAlign: "left",
                  lineHeight: 1.4,
                  width: "100%",
                }}
              >
                {faq.question}
              </Typography>
              {/* Mobile dropdown arrow */}
              <Box sx={{ display: { xs: "block", md: "none" }, ml: 1 }}>
                <IconButton
                  size="small"
                  sx={{
                    color: isExpanded ? COLOR.COLOR_SECONDARY : COLOR.GREY1,
                    transform: isExpanded ? "rotate(180deg)" : "rotate(0deg)",
                    transition: "transform 0.2s ease",
                  }}
                  aria-label={isExpanded ? "Collapse answer" : "Expand answer"}
                >
                  <ExpandMoreIcon />
                </IconButton>
              </Box>
            </ListItem>
            {/* Mobile dropdown content */}
            <Collapse in={isExpanded} timeout="auto" unmountOnExit>
              <Box sx={{ px: 2, pb: 2, display: { xs: "block", md: "none" } }}>
                {typeof faq.answer === "string" ? (
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontWeight: 400,
                      color: COLOR.GREY3,
                      lineHeight: 1.4,
                      textAlign: "left",
                      letterSpacing: "0%",
                    }}
                  >
                    {faq.answer}
                  </Typography>
                ) : faq.question === "為什麼需要成為推薦人？" ? (
                  <Box sx={{ fontSize: 16, color: COLOR.GREY3 }}>
                    {REFERRER_BENEFITS_ANSWER_TEXT_ONLY}
                  </Box>
                ) : (
                  <Box sx={{ fontSize: 16, color: COLOR.GREY3 }}>
                    {faq.answer}
                  </Box>
                )}
              </Box>
            </Collapse>
          </Box>
        );
      })}
    </List>
  );
};
